export enum AuditType {
    UNKNOWN,
    CREATED,
    UPDATED,
    DELETED
}